import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
    namespaced: true,
    state: {
        obj: {},
        list: [],
        ids: [],
        tempObj: {},
        tempRegion: [],
        statusList: null,
        statusRegion: null,
        statusGoogleSearch: null,
    },
    actions,
    mutations,
    getters
};


// WEBPACK FOOTER //
// src/store/supporter/index.js